import { queryClient } from "@/client";
import { useMutation } from "@tanstack/react-query";

import { useCRMConnectionStatusKey } from "@/hooks/api/crm/useCRMConnectionsStatus";
import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export const useCRMDisconnect = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: () => apiClient.crmConnectionsHubspot.disconnect(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: useCRMConnectionStatusKey,
      });
    },
  });

  return {
    ...mutation,
    disconnectCRM: mutation.mutate,
    disconnectCRMAsync: mutation.mutateAsync,
  };
};
